module.exports = __webpack_public_path__ + "04_hige_gray.b430e925.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer3/04_hige_gray.png
// module id = BNCW
// module chunks = 0